import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { openSimpleModal } from "@comp/modal/actions";
import { find, propEq } from "ramda";
import { sortByStoredTabOrder } from "./utils";
import { MANUAL_LOOKUP_STRING, TAB_DOCK_OPEN_NON_CLOUD_FILE, TAB_DOCK_OPEN_TAB_BY_DOCUMENT_UID, TAB_DOCK_CLOSE, TAB_DOCK_INIT, TAB_DOCK_REARRANGE_TABS, TAB_DOCK_SWITCH_TAB, TAB_CLOSE, TOGGLE_MANUAL_PANEL, SET_MANUAL_PANEL_OPEN, SET_FILE_TREE_PANEL_OPEN } from "./types";
export var tabDockInit = function tabDockInit(projectUid, allDocuments, defaultTarget) {
    var storedIndex = localStorage.getItem(projectUid + ":tabIndex");
    var storedTabOrder = localStorage.getItem(projectUid + ":tabOrder");
    var initialOpenDocuments = [];
    var initialIndex = -1;
    if (storedTabOrder && typeof storedTabOrder === "string" && storedTabOrder.length > 0 && storedTabOrder !== "[]") {
        try {
            var tabOrder = storedTabOrder ? JSON.parse(storedTabOrder) : [];
            initialIndex = storedIndex ? Number.parseInt(storedIndex) : -1;
            if (tabOrder.length > 0) {
                initialOpenDocuments = sortByStoredTabOrder(tabOrder, allDocuments);
            }
            initialIndex = Math.min(initialOpenDocuments.length - 1, initialIndex);
        }
        catch (error) {
            console.error(error);
        }
    }
    if (defaultTarget && defaultTarget.targetDocumentUid && initialOpenDocuments.length === 0 && allDocuments.length > 0) {
        initialOpenDocuments.push({
            uid: defaultTarget.targetDocumentUid
        });
    }
    else if (defaultTarget && defaultTarget.playlistDocumentsUid && initialOpenDocuments.length === 0 && allDocuments.length > 0) {
        defaultTarget.playlistDocumentsUid.forEach(function (documentUid) {
            initialOpenDocuments.push({
                uid: documentUid
            });
        });
    }
    else if ( /* eslint-disable-next-line unicorn/no-useless-length-check */allDocuments.length > 0 && /* eslint-disable-next-line unicorn/no-useless-length-check */
        allDocuments.some(function (d) {
            return d.filename === "project.csd";
        })) {
        var projectCsd = find(propEq("filename", "project.csd"), allDocuments);
        projectCsd && !find(propEq("uid", projectCsd.documentUid), initialOpenDocuments) && initialOpenDocuments.push({
            uid: projectCsd.documentUid
        });
    }
    if (initialOpenDocuments.length > 0 && initialIndex < 0) {
        initialIndex = 0;
    }
    return /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(dispatch) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({
                                type: TAB_DOCK_INIT,
                                initialOpenDocuments: initialOpenDocuments,
                                initialIndex: initialIndex
                            });
                        case 1:
                        case "end":
                            return _context.stop();
                    }
            }, _callee);
        }));
        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var rearrangeTabs = function rearrangeTabs(projectUid, modifiedDock, newActiveIndex) {
    return /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(dispatch) {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1)
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({
                                type: TAB_DOCK_REARRANGE_TABS,
                                projectUid: projectUid,
                                modifiedDock: modifiedDock,
                                newActiveIndex: newActiveIndex
                            });
                        case 1:
                        case "end":
                            return _context2.stop();
                    }
            }, _callee2);
        }));
        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();
};
export var tabOpenByDocumentUid = function tabOpenByDocumentUid(documentUid, projectUid) {
    return /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(dispatch) {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1)
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({
                                type: TAB_DOCK_OPEN_TAB_BY_DOCUMENT_UID,
                                documentUid: documentUid,
                                projectUid: projectUid
                            });
                        case 1:
                        case "end":
                            return _context3.stop();
                    }
            }, _callee3);
        }));
        return function (_x3) {
            return _ref3.apply(this, arguments);
        };
    }();
};
export var tabOpenNonCloudDocument = function tabOpenNonCloudDocument(filename, mimeType) {
    return {
        type: TAB_DOCK_OPEN_NON_CLOUD_FILE,
        isNonCloudDocument: true,
        filename: filename,
        mimeType: mimeType
    };
};
export var closeTabDock = function closeTabDock() {
    return {
        type: TAB_DOCK_CLOSE
    };
};
export var tabClose = function tabClose(activeProjectUid, documentUid, isModified) {
    return isModified ? openSimpleModal("close-unsaved-prompt", {
        projectUid: activeProjectUid,
        documentUid: documentUid
    }) : {
        type: TAB_CLOSE,
        projectUid: activeProjectUid,
        documentUid: documentUid
    };
};
export var tabSwitch = function tabSwitch(index) {
    return {
        type: TAB_DOCK_SWITCH_TAB,
        tabIndex: index
    };
};
export var lookupManualString = function lookupManualString(manualLookupString) {
    return {
        type: MANUAL_LOOKUP_STRING,
        manualLookupString: manualLookupString
    };
};
export var toggleManualPanel = function toggleManualPanel() {
    return {
        type: TOGGLE_MANUAL_PANEL
    };
};
export var setManualPanelOpen = function setManualPanelOpen(open) {
    return {
        type: SET_MANUAL_PANEL_OPEN,
        open: open
    };
};
export var setFileTreePanelOpen = function setFileTreePanelOpen(open) {
    return {
        type: SET_FILE_TREE_PANEL_OPEN,
        open: open
    };
};
